import Login from "../components/pages/login";
import TermsAndConditions from "../components/pages/terms&condition";
import PrivacyCookiePolicy from "../components/pages/privacy&Cookie";
import Dashboard from "../components/dashboard/dashboard";
import DashboardAnalyticsGlobal from "../components/dashboard/dashboardAnalytics/dashboardAnalyticsGlobal";
import CustomPageIframe from "../components/dashboard/customPageIframe";
import Integration from "../components/pages/integration";
import Chats from "../components/dashboard/chats/chats";
import ContactsGlobal from "../components/dashboard/contacts/contactsGlobal";
import OrderDetailsGlobal from "../components/dashboard/orderDetails/orderDetailsGlobal";
import ViewOrganizationDetails from "../components/dashboard/organization/viewOrganizationDetails";
import WhatsappCampaignGlobal from "../components/dashboard/whatsappCampaign/whatsappCampaignGlobal";
import WhatsappCampaignList from "../components/dashboard/whatsappCampaign/whatsappCampaignList";
import CreateWhatsappCampaign from "../components/dashboard/whatsappCampaign/createWhatsappCampaign";
import WhatsappCampaignDashboard from "../components/dashboard/whatsappCampaign/whatsappCampaignDashboard";
import WebhookGlobal from "../components/dashboard/webhook/webhookGlobal";
import ProductGlobal from "../components/pages/product/productGlobal";
import WorkflowGlobal from "../components/dashboard/workflow/workflowGlobal";
import WorkflowIndex from "../components/dashboard/workflow/workflowIndex";
import StaticWorkflowCanvas from "../components/dashboard/flowBuilder/flowBuilder";
import WhatsappChannel from "../components/dashboard/channels/global/whatsapp/whatsappChannel";
import AccountSetup from "../components/dashboard/channels/global/whatsapp/accountSetup";
import CustomRecipient from "../components/dashboard/channels/global/whatsapp/customRecipient/customRecipient";
import TemplateList from "../components/dashboard/channels/global/whatsapp/templates/templateList";
import TemplateDetails from "../components/dashboard/channels/global/whatsapp/templates/templateDetails";
import WhatsappFlowList from "../components/dashboard/channels/global/whatsapp/flows/whatsappFlowList";
import { WhatsappFlowDetails } from "../components/dashboard/channels/global/whatsapp/flows/whatsappFlowDetails";
import FacebookIntegration from "../components/dashboard/facebookIntegration/facebookIntegration";
import ViewFacebookIntegration from "../components/dashboard/facebookIntegration/viewFaceBookIntegration";
import InstagramIntegration from "../components/dashboard/instagramIntegration/instagramIntegration";
import ViewInstagramIntegration from "../components/dashboard/instagramIntegration/viewInstagramIntegration";
import SlackIntegration from "../components/dashboard/chatbot/slack/global/slackIntegration";
import ViewSlackIntegration from "../components/dashboard/chatbot/slack/global/viewSlackIntegration";
import SomethingWentWrong from "../components/pages/somethingWentWrong";
import { Navigate } from "react-router-dom";
import ChatbotList from "../components/dashboard/chatbot/chatbotList";
import FeedbackGlobal from "../components/dashboard/feedback/feedbackGlobal";
import CustomApiGlobal from "../components/dashboard/customApi/customApiGlobal";
import CustomApiList from "../components/dashboard/customApi/customApiList";
import Createdataconnector from "../components/dashboard/dataconnector/createdataconnector";
import CallAnalysisGlobal from "../components/dashboard/callAnalysis/callAnalysisGlobal";
import ZohoIntegration from "../components/dashboard/chatbot/zohoIntegrations/zohoIntegration";
import ViewZohoIntegration from "../components/dashboard/chatbot/zohoIntegrations/viewZohoIntegration";
import ChatbotDetails from "../components/dashboard/chatbot/chatbotDetails";
import { ViewChatbot } from "../components/dashboard/chatbot/viewChatbot";
import IntegrationList from "../components/dashboard/chatbot/integrations/integrationList";
import Dataconnector from "../components/dashboard/dataconnector/dataconnector";
import ChatbotSlackIntegration from "../components/dashboard/chatbot/integrations/slack/integratedChannels";
import AppointmentSchedule from "../components/dashboard/chatbot/calendly/appointmentSchedule";
import AuthoriseAccount from "../components/dashboard/chatbot/calendly/global/authoriseAccount";
import SelectCalendlyEvent from "../components/dashboard/chatbot/calendly/global/selectCalendlyEvent";
import FieldSetup from "../components/dashboard/chatbot/calendly/global/fieldSetup";
import ChatbotWhatsAppIntegration from "../components/dashboard/chatbot/whatsAppIntegration/chatbotWhatsAppIntegration";
import ZohoAccountIntegration from "../components/dashboard/chatbot/integrations/zoho/zohoIntegration";
import MessageFormatGlobal from "../components/dashboard/messageFormats/messageFormatGlobal";
import MessageFormat from "../components/dashboard/messageFormats/messageFormat";
import StaticMessageFormatForm from "../components/dashboard/messageFormats/MessageFormatForm/staticMessageFormatForm";
import TryUserChatbot from "../components/dashboard/tryChatbot/tryUserChatbot";
import SubAiChatbot from "../components/dashboard/subAiChatbot/subAiChatbot";
import PersistentMenu from "../components/dashboard/persistentMenu/persistentMenu";
import LeadGenerationGlobal from "../components/dashboard/leadGeneration/leadGenerationGlobal";
import EmailConfig from "../components/dashboard/leadGeneration/emailConfig";
import SlackConfig from "../components/dashboard/leadGeneration/slackConfig";
import DataListGlobal from "../components/dashboard/dynamicData/dataListGlobal";
import CreateChatbot from "../components/dashboard/chatbot/createChatbot";
import PageNotFound from "../components/pages/pageNotFound";
import { flagShowGetStartedPage, hasAIChatbotPageAccess, hasCallAnalysisPageAccess, hasCampaignPageReadAccess, hasChannelsPageReadAccess, hasContactPageReadAccess, hasCustomAPIPageReadAccess, hasDashboardPageReadAccess, hasInboxReadAccess, hasIntentPageReadAccess, hasOrderDetailsPageReadAccess, hasProductPageReadAccess, hasVoiceAgentPageReadAccess, hasWebhookManageAccess, hasRuleBasedChatbotPageAccess, hasSupportTicketPageAccess, hasUserLoggedInPermission, isAdmin, hasApiKeyPageAccess, isFeatureDisabled, CHRONOX_FEATURES, hasBillingUsageManageAccess } from "../utils/constants";
import GetStartedGlobal from "../components/pages/getStarted/getStartedPageGlobal";
import IntentGlobal from "../components/dashboard/intent/intentGlobal";
import KnowledgeBaseGlobal from "../components/pages/knowledgeBase/knowledgeBaseGlobal";
import RuleBasedInbox from "../pages/ruleBasedInbox";
import VoiceAgentGlobal from "../components/dashboard/voiceAgent/voiceAgentGlobal";
import CreateVoiceAgent from "../components/dashboard/voiceAgent/createVoiceAgent";
import VoiceAgentList from "../components/dashboard/voiceAgent/voiceAgentList";
import VoiceAgentDeployments from "../components/dashboard/voiceAgent/voiceAgentDeployments";
import VoiceAgentDetails from "../components/dashboard/voiceAgent/voiceAgentDetails";
import VoiceAgentCustomApi from "../components/dashboard/voiceAgent/voiceAgentCustomApi";
import TemplateLibrary from "../components/dashboard/templatelibrary/TemplateLibrary";
import ApiKeysGlobal from "../pages/apiKeys";
import ModifyWhatsAppTemplate from "../components/dashboard/templatelibrary/ModifyWhatsAppTemplate/ModifyWhatsAppTemplate";
import CarouselTemplateGroup from "../components/dashboard/channels/global/whatsapp/carouselTemplateGroups";
import Organization from "../components/dashboard/organization";
import TicketSubStatus from "../components/dashboard/organization/ticketSubStatus";
import PaymentConfiguration from "../components/dashboard/channels/global/whatsapp/paymentConfiguration";
import OrganizationTeams from "../components/dashboard/organization/teams/index.teams";
import ConversionLeadsGlobal from "../pages/conversionLeads";
// import CallAnalysisDashboard from "../components/dashboard/callAnalysis/callAnalysisDashboard";
// import CallAnalysisDetails from "../components/dashboard/callAnalysis/callAnalysisDetails";
// import NewCallRecord from "../components/dashboard/callAnalysis/newCallRecord";
import BillingUsageGlobal from "../pages/billing/index.billing";

export const createRoute = (path, element, children) => {
    return {
        path,
        element,
        ...(children ? { children } : {})
    };
}

export const loginRoutes = [
    createRoute("/login", <Login />),
    createRoute("*", <Login />),
]

export const privacyPolicyRoutes = [
    createRoute("/privacy-policy", <PrivacyCookiePolicy />),
    createRoute("/terms", <TermsAndConditions />),
]
export const ruleBasedInboxRoutes = () => {
    return [
        createRoute("/ruleBasedInbox", <RuleBasedInbox />)
    ]
}

// export const ruleBasedInboxRoutes = [
//     createRoute("/ruleBasedInbox", <RuleBasedInbox />)
// ]
export const whatsAppChannelIntegrationRoutes = () => {
    return [
        createRoute("/channels/viewintegration/whatsapp", <WhatsappChannel />, [
            createRoute("", <AccountSetup flagPhone={false} />),
            createRoute("/channels/viewintegration/whatsapp/phonenumbers", <AccountSetup flagPhone={true} />),
            createRoute("/channels/viewintegration/whatsapp/phonenumbers/customRecipient", <CustomRecipient />),
            createRoute("/channels/viewintegration/whatsapp/templatemessages", <TemplateList />),
            createRoute("/channels/viewintegration/whatsapp/legacy/templateinfo", <TemplateDetails />),
            createRoute("/channels/viewintegration/whatsapp/templateLibrary", <TemplateLibrary />),
            createRoute("/channels/viewintegration/whatsapp/templateLibrary/modifyTemplate", <ModifyWhatsAppTemplate />),
            createRoute("/channels/viewintegration/whatsapp/flows", <WhatsappFlowList />),
            createRoute("/channels/viewintegration/whatsapp/flowDetails", <WhatsappFlowDetails />),
            createRoute("/channels/viewintegration/whatsapp/paymentConfiguration", <PaymentConfiguration />),
            createRoute("/channels/viewintegration/whatsapp/carouselTemplateGroups", <CarouselTemplateGroup />),
        ]),
    ]
}

export const facebookChannelIntegrationRoutes = () => {
    return [
        createRoute("/channels/viewintegration/facebook", <FacebookIntegration />, [
            createRoute("", <ViewFacebookIntegration flagPage={true} />),
        ]),
    ]
}

export const instagramChannelIntegrationRoutes = () => {
    return [
        createRoute("/channels/viewintegration/instagram", <InstagramIntegration />, [
            createRoute("", <ViewInstagramIntegration flagPage={true} />),
        ]),
    ]
}

export const slackChannelIntegrationRoutes = () => {
    return [
        createRoute("/channels/viewintegration/slack", <SlackIntegration />, [
            createRoute("", <ViewSlackIntegration flagPage={false} />),
            createRoute("/channels/viewintegration/slack/channels", <ViewSlackIntegration flagPage={true} />),
        ]),
    ]
}

export const zohoIntegrationRoutes = () => {
    return [
        createRoute("/channels/viewintegration/zoho", <ZohoIntegration />, [
            createRoute("", <ViewZohoIntegration />),
        ]),
    ]
}

export const whatsAppCampaignRoutes = () => {
    return [
        createRoute("/whatsappcampaign", <WhatsappCampaignGlobal />, [
            createRoute("", <WhatsappCampaignList />),
            createRoute("/whatsappcampaign/createnewcampaign", <CreateWhatsappCampaign />),
            createRoute("/whatsappcampaign/dashboard", <WhatsappCampaignDashboard />),
        ]),
    ]
}

export const workflowRoutes = () => {
    return [
        createRoute("/workflow", <WorkflowGlobal />, [
            createRoute("", <WorkflowIndex />),
            createRoute("/workflow/staticWorkflowDetails", <StaticWorkflowCanvas />),
        ]),
    ]
}

export const voiceAgentRoutes = () => {
    return [
        createRoute("/voiceagent", <VoiceAgentGlobal />, [
            createRoute("", <VoiceAgentList />),
            createRoute("/voiceagent/createvoiceagent", <VoiceAgentDetails />, [
                createRoute("", <CreateVoiceAgent />),
                createRoute("/voiceagent/createvoiceagent/deployments", <VoiceAgentDeployments />),
                createRoute("/voiceagent/createvoiceagent/customapi", <VoiceAgentCustomApi />),
            ])
        ]),
    ]
}

export const customAPIRoutes = () => {
    return [
        createRoute("/customAPI", <CustomApiGlobal />, [
            createRoute("", <CustomApiList />),
            createRoute("/customAPI/createCustomAPI", <Createdataconnector />),
        ]),
    ]
}

// The Call Analysis page is disabled as it is a client-specific custom feature.
// export const callAnalysisRoutes = () => {
//     return [
//         createRoute("/callanalysis", <CallAnalysisGlobal />, [
//             createRoute("", <CallAnalysisDashboard />),
//             createRoute("/callanalysis/callrecords", <CallAnalysisDetails />),
//             createRoute("/callanalysis/callrecords/newcallrecords", <NewCallRecord />),
//         ]),
//     ]
// }

export const chatbotLevelRoutes = (lead_id, userDetail) => {
    return [
        createRoute("/chatbot/viewchatbot", <ChatbotDetails />, [
            createRoute("", <ViewChatbot currentTab="Settings" />),
            createRoute("/chatbot/viewchatbot/basicdetail", <ViewChatbot currentTab="Settings" />),
            createRoute("/chatbot/viewchatbot/integration", <ViewChatbot currentTab="Integrations" />, [
                createRoute("", <IntegrationList />),
                createRoute("/chatbot/viewchatbot/integration/customAPI", <Dataconnector />),
                createRoute("/chatbot/viewchatbot/integration/slack", <ChatbotSlackIntegration />),
                createRoute("/chatbot/viewchatbot/integration/calendly", <AppointmentSchedule />, [
                    createRoute("", <AuthoriseAccount />),
                    createRoute("/chatbot/viewchatbot/integration/calendly/selectCalendlyEvent", <SelectCalendlyEvent />),
                    createRoute("/chatbot/viewchatbot/integration/calendly/fieldSetup", <FieldSetup />),
                ]),
                createRoute("/chatbot/viewchatbot/integration/whatsapp", <ChatbotWhatsAppIntegration />),
                createRoute("/chatbot/viewchatbot/integration/zoho", <ZohoAccountIntegration />),
            ]),
            // createRoute("/chatbot/viewchatbot/inbox", <Chats />),
            ...(isAdmin(userDetail)
                ? [createRoute("/chatbot/viewchatbot/messageformat", <MessageFormatGlobal />, [
                    createRoute("", <MessageFormat />),
                    createRoute("/chatbot/viewchatbot/messageformat/staticformat", <StaticMessageFormatForm />),
                ])]
                : []),
            createRoute("/chatbot/viewchatbot/channels/whatsapp", <ViewChatbot currentTab="WhatsApp Integration" />),
            createRoute("/chatbot/viewchatbot/channels/facebook", <ViewChatbot currentTab="Facebook Integration" />),
            createRoute("/chatbot/viewchatbot/channels/instagram", <ViewChatbot currentTab="Instagram Integration" />),
            createRoute("/chatbot/viewchatbot/channels/website", <ViewChatbot currentTab="Embed Link & Domains" />),
            createRoute("/chatbot/viewchatbot/channels/slack", <ViewChatbot currentTab="Slack" />),
            createRoute("/chatbot/viewchatbot/trychatbot", <TryUserChatbot currentTab="tryChatbot" />),
            createRoute("/chatbot/viewchatbot/subaichatbot", <SubAiChatbot />),
            createRoute("/chatbot/viewchatbot/persistentmenu", <PersistentMenu />),
            createRoute("/chatbot/viewchatbot/leadgeneration", <LeadGenerationGlobal />, [
                createRoute("", <LeadGenerationGlobal />),
                createRoute("/chatbot/viewchatbot/leadgeneration/createleadgeneration", <LeadGenerationGlobal />),
                ...(lead_id
                    ? [
                        createRoute("/chatbot/viewchatbot/leadgeneration/email", <EmailConfig />),
                        createRoute("/chatbot/viewchatbot/leadgeneration/spreadsheet", <EmailConfig />),
                        createRoute("/chatbot/viewchatbot/leadgeneration/slack", <SlackConfig />),
                    ]
                    : []),
            ]),
            createRoute("/chatbot/viewchatbot/products", <DataListGlobal />),
        ]),
    ]
}

export const customPageRoutes = (customPagesData) => {
    return (customPagesData?.map(page =>
        createRoute(page.custom_page_slug, <CustomPageIframe />)
    ) ?? []);
}

export const errorPageRoutes = () => {
    return [
        createRoute("/error", <SomethingWentWrong />),
        createRoute("*", <Navigate to="/" />),
    ]
}

export const somethingWentWrongPageRoutes = () => {
    return [
        createRoute("*", <SomethingWentWrong flagStaticErrorPage />)
    ]
}

export const apiKeyPageRoutes = createRoute("/apiKeys", <ApiKeysGlobal />);

export const organizationRoutes = (userDetail) => {
    return [
        createRoute("/organization", <Organization />, [
            createRoute("", <ViewOrganizationDetails />),
            createRoute("/organization/teams", <OrganizationTeams />),

            ...(!isFeatureDisabled(userDetail, CHRONOX_FEATURES['THREAD_TICKETING']) ? [
                    createRoute("/organization/ticketSubstatus", <TicketSubStatus />)
            ] : [])
        ])
    ]
}

export const billingRoutes = () => {
    return [
        createRoute("/billing-usage", <BillingUsageGlobal />),
        createRoute("/plans", <BillingUsageGlobal />),
    ]
}

export const aapdujunagadhRoutes = (userDetail, apiRoutesPermissionAssignment) => {
    return [
        createRoute("/", <Dashboard />, [
            // Root child routes
            createRoute("/", <DashboardAnalyticsGlobal />),
            createRoute("/dashboard", <DashboardAnalyticsGlobal />),

            createRoute("/channels", <Integration mainSection={true} />),
            // createRoute("/inbox", <Chats mainSection={true} />),
            createRoute("/inbox",  <RuleBasedInbox />),
            createRoute("/ruleBasedInbox", <RuleBasedInbox />),
            createRoute("/contacts", <ContactsGlobal />),
            createRoute("/intent", <IntentGlobal />),
            createRoute("/orderDetails", <OrderDetailsGlobal />),
            // createRoute("/organization", <ViewOrganizationDetails />),
            ...organizationRoutes(userDetail),

            // API Key Routes
            ...(hasApiKeyPageAccess(apiRoutesPermissionAssignment, userDetail) ? [
                apiKeyPageRoutes
            ] : []),

            // Custom API
            ...customAPIRoutes(),

            // createRoute("/analytics", <WorkflowAnalytics />),

            // WhatsApp Campaign
            ...whatsAppCampaignRoutes(),

            createRoute("/webhook", <WebhookGlobal />),
            createRoute("/product", <ProductGlobal />),

            // Workflow
            ...workflowRoutes(),

            // Voice Agent
            ...voiceAgentRoutes(),

            // WhatsApp Channel Integration
            ...whatsAppChannelIntegrationRoutes(),

            // Facebook Integration
            ...facebookChannelIntegrationRoutes(),

            // Instagram Integration
            ...instagramChannelIntegrationRoutes(),

            // Slack Integration
            ...slackChannelIntegrationRoutes(),
        ]),

        // Error + Catch-all
        ...errorPageRoutes(),
    ]
}

export const mawhibaRoutes = (lead_id, userDetail, apiRoutesPermissionAssignment) => {
    return [
        createRoute("/", <Dashboard />, [
            createRoute("/", <WhatsappCampaignGlobal />, [
                createRoute("", <WhatsappCampaignList />), // index
                createRoute("/whatsappcampaign/createnewcampaign", <CreateWhatsappCampaign />),
                createRoute("/whatsappcampaign/dashboard", <WhatsappCampaignDashboard />),
            ]),

            // Inbox Page
            ...(hasInboxReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
                // createRoute("/inbox", <Chats mainSection={true} />),
                createRoute("/ruleBasedInbox", <RuleBasedInbox />),
                createRoute("/inbox", <RuleBasedInbox />)
            ] : []),

            // AI Chatbot Page
            ...(hasAIChatbotPageAccess(apiRoutesPermissionAssignment, userDetail) ? [
                createRoute("/chatbot", <ChatbotList />),
                createRoute("/createChatbot", <CreateChatbot />),

                // Knowledge Base Page
                createRoute("/knowledge-base", <KnowledgeBaseGlobal />),

                // AI Chatbot Details Pages
                ...chatbotLevelRoutes(lead_id, userDetail)
            ] : []),

            // Support Ticket Page
            // ...(hasSupportTicketPageAccess(apiRoutesPermissionAssignment, userDetail) ? [
            //     createRoute("/supportTicket", <FeedbackGlobal />)
            // ] : []),

            // Channels Page
            ...(hasChannelsPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
                createRoute("/channels", <Integration mainSection={true} />),
                ...whatsAppChannelIntegrationRoutes(),
                ...facebookChannelIntegrationRoutes(),
                ...instagramChannelIntegrationRoutes(),
                ...slackChannelIntegrationRoutes(),
                ...zohoIntegrationRoutes()
            ] : []),

            // Contact Page
            ...(hasContactPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
                createRoute("/contacts", <ContactsGlobal />)
            ] : []),

            // createRoute("/organization", <ViewOrganizationDetails />),
            ...organizationRoutes(userDetail),

            // API Key Routes
            ...(hasApiKeyPageAccess(apiRoutesPermissionAssignment, userDetail) ? [
                apiKeyPageRoutes
            ] : []),

            // Whatsapp Campaign Page
            ...(hasCampaignPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
                createRoute("/whatsappcampaign", <WhatsappCampaignGlobal />, [
                    createRoute("", <WhatsappCampaignList />),

                    // Create New Campaign Page
                    createRoute("/whatsappcampaign/createnewcampaign", <CreateWhatsappCampaign />),

                    // Campaign Dashboard Page
                    createRoute("/whatsappcampaign/dashboard", <WhatsappCampaignDashboard />)
                ])
            ] : []),

            // Custom API
            ...(hasCustomAPIPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
                ...customAPIRoutes()
            ] : []),

            // Webhook Page
            ...(hasWebhookManageAccess(apiRoutesPermissionAssignment, userDetail) ? [
                createRoute("/webhook", <WebhookGlobal />)
            ] : []),

            // The Call Analysis page is disabled as it is a client-specific custom feature.
            // ...(hasCallAnalysisPageAccess(apiRoutesPermissionAssignment, userDetail) ? [
            //     ...callAnalysisRoutes()
            // ] : []),
        ]),

        ...errorPageRoutes(),
    ]
}

export const timSafranskyRoutes = (customPagesData, userDetail, apiRoutesPermissionAssignment) => {
    return [
        createRoute("/", <Dashboard />, [
            // createRoute("/", <CallAnalysisGlobal />),
            createRoute("/", <Dashboard />),

            // Nested callanalysis routes
            // The Call Analysis page is disabled as it is a client-specific custom feature.
            // ...callAnalysisRoutes(),

            // Dynamic custom page route if matches window location
            ...customPageRoutes(customPagesData),
            // createRoute("/organization", <ViewOrganizationDetails />),
            ...organizationRoutes(userDetail),

            // API Key Routes
            ...(hasApiKeyPageAccess(apiRoutesPermissionAssignment, userDetail) ? [
                apiKeyPageRoutes
            ] : []),
        ]),


        createRoute("/error", <SomethingWentWrong />),
        createRoute("*", <PageNotFound />),
    ]
}

export const adminRoutes = (customPagesData, lead_id, userDetail, apiRoutesPermissionAssignment, vendorData) => {
    // Routes for Organization Owner, admin and member.
    return [
        createRoute("/", <Dashboard />, [

            ...(flagShowGetStartedPage(userDetail) ? [
                createRoute("/", <GetStartedGlobal />),
                createRoute("/get-started", <GetStartedGlobal />),
                createRoute("/dashboard", <DashboardAnalyticsGlobal />)
            ] : hasDashboardPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
                createRoute("/", <DashboardAnalyticsGlobal />),
                createRoute("/dashboard", <DashboardAnalyticsGlobal />)
            ] : []),

            // Dynamic custom pages
            ...customPageRoutes(customPagesData),


            // Workflow
            ...(hasRuleBasedChatbotPageAccess(apiRoutesPermissionAssignment, userDetail) ? [
                ...workflowRoutes()
            ] : []),

            // Custom API
            ...(hasCustomAPIPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
                ...customAPIRoutes()
            ] : []),

            // Product Page
            ...(hasProductPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
                createRoute("/product", <ProductGlobal />)
            ] : []),
            
            // Intent Page
            ...(hasIntentPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
                createRoute("/intent", <IntentGlobal />)
            ] : []),

            // Webhook Page
            ...(hasWebhookManageAccess(apiRoutesPermissionAssignment, userDetail) ? [
                createRoute("/webhook", <WebhookGlobal />)
            ] : []),

            // AI Chatbot Page
            ...(hasAIChatbotPageAccess(apiRoutesPermissionAssignment, userDetail) ? [
                createRoute("/chatbot", <ChatbotList />),
                createRoute("/createChatbot", <CreateChatbot />),

                // Knowledge Base Page
                createRoute("/knowledge-base", <KnowledgeBaseGlobal />),

                // AI Chatbot Details Pages
                ...chatbotLevelRoutes(lead_id, userDetail)
            ] : []),

            // Inbox Page
            ...(hasInboxReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
                // createRoute("/inbox", <Chats mainSection={true} />),
                createRoute("/ruleBasedInbox", <RuleBasedInbox />),
                createRoute("/inbox", <RuleBasedInbox />)
            ] : []),

            // Support Ticket Page
            // ...(hasSupportTicketPageAccess(apiRoutesPermissionAssignment, userDetail) ? [
            //     createRoute("/supportTicket", <FeedbackGlobal />)
            // ] : []),

            // Channels Page
            ...(hasChannelsPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
                createRoute("/channels", <Integration mainSection={true} />),
                ...whatsAppChannelIntegrationRoutes(),
                ...facebookChannelIntegrationRoutes(),
                ...instagramChannelIntegrationRoutes(),
                ...slackChannelIntegrationRoutes(),
                ...zohoIntegrationRoutes()
            ] : []),

            // Order Details Page
            ...(hasOrderDetailsPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
                createRoute("/orderDetails", <OrderDetailsGlobal />)
            ] : []),

            ...(hasUserLoggedInPermission(apiRoutesPermissionAssignment, userDetail) ? [
                createRoute("/conversionLeads", <ConversionLeadsGlobal />)
            ] : []),

            // Contact Page
            ...(hasContactPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
                createRoute("/contacts", <ContactsGlobal />)
            ] : []),

            // createRoute("/organization", <ViewOrganizationDetails />),
            ...organizationRoutes(userDetail),

            // API Key Routes
            ...(hasApiKeyPageAccess(apiRoutesPermissionAssignment, userDetail) ? [
                apiKeyPageRoutes
            ] : []),

            // Whatsapp Campaign Page
            ...(hasCampaignPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
                createRoute("/whatsappcampaign", <WhatsappCampaignGlobal />, [
                    createRoute("", <WhatsappCampaignList />),

                    // Create New Campaign Page
                    createRoute("/whatsappcampaign/createnewcampaign", <CreateWhatsappCampaign />),

                    // Campaign Dashboard Page
                    createRoute("/whatsappcampaign/dashboard", <WhatsappCampaignDashboard />)
                ])
            ] : []),

            // Voice Agent Page
            ...(hasVoiceAgentPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
                ...voiceAgentRoutes()
            ] : []),

            // The Call Analysis page is disabled as it is a client-specific custom feature.
            // ...(hasCallAnalysisPageAccess(apiRoutesPermissionAssignment, userDetail) ? [
            //     ...callAnalysisRoutes()
            // ] : []),

            // Billing Routes
            ...(hasBillingUsageManageAccess(apiRoutesPermissionAssignment, userDetail, vendorData) ? [
                ...billingRoutes()
            ] : []),
        ]),

        ...errorPageRoutes(),
    ]
}

export const agentRoutes = (userDetail) => {
    return [
        createRoute("/", <Dashboard />, [
            // createRoute("/", <DashboardAnalyticsGlobal />), 
            createRoute("/", flagShowGetStartedPage(userDetail) ? <GetStartedGlobal /> : <DashboardAnalyticsGlobal />),
            createRoute("/get-started", <GetStartedGlobal />),
            createRoute("/dashboard", <DashboardAnalyticsGlobal />),
            ...ruleBasedInboxRoutes(),
            // createRoute("/organization", <ViewOrganizationDetails />),
            ...organizationRoutes(userDetail),

            // API Key Routes
            apiKeyPageRoutes,
            // createRoute("/inbox", <Chats mainSection={true} />),
            createRoute("/inbox", <RuleBasedInbox />), 
            createRoute("/ruleBasedInbox", <RuleBasedInbox />),
        ]), 
       ...errorPageRoutes(),
    ];
}